const config = {
  googleAnalyticsTrackingId: "UA-90851529-2",
  mixpanelToken: "328388502d0f75f66811fc1137490aaa",
  apiUrl: null,
  apiUrlPci: null,
  features: {
    // usage:
    // featureKeyName: boolean|userID[]
  },
  fingerprintjs: {
    "token": "XNZb6VbuXWRafpnwIsoQ",
    "endpoint": "https://fp.sunbit.in"
  },
  sampling: {
    "endpoint": "https://api.sunbit.in/sampling/api/v1/sampling"
  },
  recaptchaKey: "6LdKn6kbAAAAAAOh8yNyxktuEbAD56BFPpD67upt",
  launchDarklyClientId: '6499466b1a95581354454ed6',
  mySunbitBrandBaseUrl : 'https://static.sunbit.in/my-sunbit/brand-cards-images-v2/',
};

export default config;



// WEBPACK FOOTER //
// ./src/config/default.js